export function menuListeners() {
    console.log("HI");
    [...document.querySelectorAll("#menu-menu-1 .menu-item-has-children")].forEach((menuDropdown) => {
        console.log(menuDropdown);
        if (menuDropdown) {
            menuDropdown.addEventListener("click", () => {
                var content = menuDropdown.querySelector(".sub-menu");

                var isCollapsed = content.getAttribute("data-collapsed") === "true";

                if (isCollapsed) {
                    expandSection(content);
                    content.setAttribute("data-collapsed", "false");
                    menuDropdown.classList.add("open");
                } else {
                    collapseSection(content);
                    menuDropdown.classList.remove("open");
                }
            });
        }
        // start menu collapsed
        if (menuDropdown) {
            var content = menuDropdown.querySelector(".sub-menu");
            if (content) {
                collapseSection(content);
            }
        }
    });
}
function collapseSection(element, till = 0) {
    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = element.scrollHeight;

    // temporarily disable all css transitions
    var elementTransition = element.style.transition;
    element.style.transition = "";

    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we
    // aren't transitioning out of 'auto'
    requestAnimationFrame(function () {
        element.style.height = sectionHeight + "px";
        element.style.transition = elementTransition;

        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(function () {
            element.style.height = till + "px";
        });
    });

    // mark the section as "currently collapsed"
    element.setAttribute("data-collapsed", "true");
}

function expandSection(element) {
    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = element.scrollHeight;

    // have the element transition to the height of its inner content
    element.style.height = sectionHeight + "px";

    // when the next css transition finishes (which should be the one we just triggered)
    element.addEventListener(
        "transitionend",
        function (e) {
            // remove "height" from the element's inline styles, so it can return to its initial value
            element.style.height = null;
        },
        {
            once: true,
        },
    );

    // mark the section as "currently not collapsed"
    element.setAttribute("data-collapsed", "false");
}
